export default "__VITE_ASSET__DGMSg9eQ__"